import { SPANISH_SUPPORT_FLAG } from 'approot/lesson/lesson.constants';
import { localStorageWrapper } from 'approot/shared/storage';

export function isSpanishSupportEnabled() {
  return localStorageWrapper.getItem(SPANISH_SUPPORT_FLAG) === 'true';
}

export function setSpanishSupportEnabled(value: boolean) {
  localStorageWrapper.setItem(SPANISH_SUPPORT_FLAG, value.toString());
}

export function toggleSpanishSupportEnabled() {
  const spanishEnabled = isSpanishSupportEnabled();
  if (spanishEnabled) {
    setSpanishSupportEnabled(false);
  } else {
    setSpanishSupportEnabled(true);
  }
}
